const Consts = {
  boardPos: { x: 0, y: 0 },
  cellDim: { w: 75, h: 75 },
  boardDim: { w: 7, h: 6 },
};

export default Consts;
